import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "د کوکي ګانو خبرتیا",
    description:
      "موږ اړينې کوکي ګانې کاروو تر څو ډاډ ترلاسه کړو چې دا وېب‌پاڼه په سمه توګه کار کوي. موږ همدارنګه اختیاري د تعقیب کوکي ګانې کاروو چې مرسته وکړي موږ پوه شو چې تاسو له زمونږ وېب‌پاڼې سره څنګه تعامل کوئ. دا اختیاري کوکي ګانې یوازې ستاسې په رضا سره فعالیږي.",
    acceptAllBtn: "ټولې ومنه",
    acceptNecessaryBtn: "ټولې رد کړه",
    showPreferencesBtn: "انفرادي غوره توبونه اداره کړه",
  },
  preferencesModal: {
    title: "د کوکي ګانو غوره توبونه اداره کړه",
    acceptAllBtn: "ټولې ومنه",
    acceptNecessaryBtn: "ټولې رد کړه",
    savePreferencesBtn: "اوسنی انتخاب ومنه",
    closeIconLabel: "کړکۍ بنده کړه",
    sections: [
      {
        title: "د کوکي ګانو کارول",
        description:
          "موږ د کوکي ګانو څخه ګټه اخلو ترڅو د دې وېب‌پاڼې اړينې دندې ملاتړ کړو او ستاسې د لټون تجربه ښه کړو.",
      },
      {
        title: "سخت اړینې کوکي ګانې",
        description:
          "دا کوکي ګانې د وېب‌پاڼې د سم کار کولو لپاره اړینې دي، د بېلګې په توګه د کاروونکي د تصدیق لپاره.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "نوم",
            domain: "خدمت",
            description: "تشریح",
            expiration: "مهلت",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکي د ډیجیټل ټولنې پلاتفورم لخوا د کاروونکي تصدیق لپاره ځای پر ځای شوی.",
              expiration: "ناسته",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکي د ډیجیټل ټولنې پلاتفورم لخوا د کاروونکي تصدیق لپاره ځای پر ځای شوی",
              expiration: "ناسته",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "دا کوکي د انسانانو او روباټونو د توپیر لپاره کارول کېږي ترڅو وېب‌پاڼه د اتوماتي ناوړه ګټې اخیستنې څخه وژغوري. هیڅ شخصي معلومات نه راټولېږي.",
              expiration: "۳۰ دقیقې",
            },
          ],
        },
      },
      {
        title: "تحلیل",
        description:
          "د تحلیل لپاره کارېدونکې کوکي ګانې د معلوماتو په راټولولو کې مرسته کوي چې خدماتو ته اجازه ورکوي پوه شي کاروونکي څنګه له ځانګړي خدمت سره اړیکه نیسي. دا لیدونه د منځپانګې په ښه کولو او د ښه ځانګړتیاوو د جوړولو کې مرسته کوي چې د کاروونکي تجربه ښه کړي.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "نوم",
            domain: "خدمت",
            description: "تشریح",
            expiration: "مهلت",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکي د <a href="https://business.safety.google/adscookies/">Google Analytics</a> لخوا ځای پر ځای شوی',
              expiration: "د ۱۲ ورځو وروسته پای ته رسېږي",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکي د <a href="https://business.safety.google/adscookies/">Google Analytics</a> لخوا ځای پر ځای شوی',
              expiration: "ناسته",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "هغه زېرمه فعالوي چې د تحلیل سره تړاو لري، لکه د لیدنې موده.";

export { translation, servicesLabel };
